import NotifyAndSendMessageButton, {
  type NotifyAndSendMessageButtonProps,
} from "@features/vessel-call/vessel-call-status/PortServices/components/NotifyAndSendMessageButton";

type CustomSendButtonByEntityType = {
  PORT_SERVICES: React.ComponentType<NotifyAndSendMessageButtonProps>;
  // ANOTHER_ONE: React.ComponentType<OtherProps>;
};
export type EntityType = keyof CustomSendButtonByEntityType;

export const customSendButtonByEntityType: CustomSendButtonByEntityType = {
  PORT_SERVICES: NotifyAndSendMessageButton,
};
